import { params } from '@didi/driver-biz-sdk'
import { env } from '@didi/utils'
import store from '@didi/store'

type PageConfig = {
  jumpUrl: string,
  failJumpUrl: string,
  productLine: number,
  env?: 'production'|'development'|'pre'
}

const urlMap = {
  production: 'https://page.udache.com/public-biz/authorization-management/index.html#/detail',
  pre: 'http://prepage.udache.com/public-biz/authorization-management/index.html#/detail',
  development: 'http://middle.didichuxing.com/authorization-management/index.html#/detail'
} as const

function linkAuthorizationManagement(config: PageConfig): void {
  config.env = config.env || (process.env.API_ENV === 'production' ? 'production' : 'development') // TODO
  const authUrl = process.env.API_ENV === 'production' ? urlMap.production : urlMap[config.env]
  if (!authUrl) return

  let jumpUrl = config.jumpUrl
  let failJumpUrl = config.failJumpUrl
  if (params.urlParams.ticket) {
    jumpUrl = `${jumpUrl}&ticket=${encodeURIComponent(params.urlParams.ticket)}`
    failJumpUrl = `${failJumpUrl}&ticket=${encodeURIComponent(params.urlParams.ticket)}`
  }
  if (params.urlParams.api) {
    jumpUrl = `${jumpUrl}&api=${params.urlParams.api}`
    failJumpUrl = `${failJumpUrl}&api=${params.urlParams.api}`
  }
  let url = `${authUrl}?product_line=${config.productLine}&businees_jump_url=${encodeURIComponent(jumpUrl)}&businees_fail_jump_url=${encodeURIComponent(failJumpUrl)}`
  if (params.urlParams.ticket) {
    url = `${url}&ticket=${encodeURIComponent(params.urlParams.ticket)}`
  }

  store.set('link_auth', 'true')
  if (env.rainbow) {
    window.location.replace(url)
  } else {
    window.location.href = url
  }
}

export {
  linkAuthorizationManagement
}
